import React from "react";
import styles from "./css/About.module.css";
import ImageSlider from "../Experience/ImageSlider/ImageSlider";

export default function About() {
  return (
    <div className={styles.containerExperience}>
      <div className={styles.boxExperience}>
        <h3 className={styles.experiencetext}>About Us</h3>
      </div>
      <ImageSlider />
    </div>
  );
}
